import React, { ReactNode } from 'react';
import { Divider, Paper, Stack, Typography } from '@mui/material';
import { DEFAULT_SPACING, DOUBLE_SPACING } from 'src/theme/style-consts';
import { theme } from 'src/theme/mui-theme';

type Props = {
    title: string;
    titleIcon?: ReactNode;
    titleAction?: ReactNode;
    children: ReactNode;
};

export const SettingsSection = ({ title, titleIcon, titleAction, children }: Props) => {
    return (
        <Paper variant="outlined" sx={{ padding: DOUBLE_SPACING }}>
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                useFlexGap
                sx={{ color: titleIcon ? theme.palette.primary.main : undefined }}
            >
                {titleIcon}
                <Typography variant="h6" sx={{ textTransform: titleIcon ? 'uppercase' : undefined }}>
                    {title}
                </Typography>
                {titleAction}
            </Stack>
            <Divider sx={{ marginTop: DEFAULT_SPACING, marginBottom: DOUBLE_SPACING }} />
            {children}
        </Paper>
    );
};
